import {
  MapPin,
  Mail,
  Phone,
  Clock,
} from "lucide-react";

import GlobalPresenceMap from "./map";
const items = [
  {
    icon: MapPin,
    title: "Head Office",
    text: "New City Phase 2, Wah Cantt, Islamabad, Pakistan",
  },
  {
    icon: Mail,
    title: "Email Support",
    text: "hr@keymech.org",
  },
  {
    icon: Phone,
    title: "Phone No",
    text: "+92 320 5504858",
  },
  {
    icon: Clock,
    title: "Working Hours",
    text: "24/7",
  },
];

const ContactInfo = () => {
  return (
    <div>


      <h2 className="text-4l font-bold leading-tight mt-10 mb-6 ">
        Let's Get in{" "}
        <span className="text-purple-700">
          Touch
        </span>
      </h2>

      <p className="text-gray-600 leading-8 mb-10">
        We provide mechanical, electrical
        and industrial design.  Our experience spans a wide range
        of industries, delivering innovative, reliable, and high-quality
        engineering solutions across multiple regions!
      </p>

      {/* Contact Information */}
      <div className="grid md:grid-cols-2 gap-8 mb-12">
        {items.map((item, index) => {
          const Icon = item.icon;

          return (
            <div
              key={index}
              className="flex gap-4"
            >
              <div className="w-100 h-11 w-max-full rounded-full bg--200 flex items-center justify-center flex-shrink-0">
                <Icon
                  size={20}
                  className="text-purple-700"
                />
              </div>

              <div>
                <h4 className="font-semibold text-lg mb-1">
                  {item.title}
                </h4>

                <p className="text-sm text-gray-600 leading-6">
                  {item.text}
                </p>
              </div>
            </div>
          );
        })}
      </div>

      {/* Regions We Serve */}
      <div className="  overflow-hidden ">
        <GlobalPresenceMap />


      </div>
    </div>
  );
};
export default ContactInfo;